export default __webpack_public_path__ + "static/media/github.f1102180.png";